<script setup lang="ts">

import { AppText } from '@shared/ui/typography'
import { ModalConfirmation } from '@shared/ui/modals'

import { useModalDisciplineTaskConfirm } from '../../model/modal-discipline-task-confirm.hook'

defineOptions({
  name: 'ModalDisciplineTaskDelete',
})

const {
  refIsDeleteOpen,
  refIsLoading,
  refDeleteDetail,
  closeModal,
  deleteTask,
} = useModalDisciplineTaskConfirm()
</script>

<template>
  <ModalConfirmation
    :show="refIsDeleteOpen"
    :loading="refIsLoading"
    :disabled="refIsLoading"
    mode="delete"
    title="Delete task?"
    cancel-title="Keep it"
    @click:confirm="deleteTask"
    @click:cancel="closeModal"
  >
    <template #content>
      <AppText
        name="body1"
        color="slate-700"
      >
        {{ refDeleteDetail }}
      </AppText>
    </template>
  </ModalConfirmation>
</template>
